import { useAppSelector, useAppDispatch } from "../../../../redux/store";

import {
  changeInvoicesFilter,
  clearFilters,
} from "../../../../redux/slices/invoicesSlice";
import { Button, ChipMultiGroup, PageHeader, Toolbar } from "../../../../ui";

type Props = {
  // The link exports live here, beside the filters they obey. The optional
  // argument names a book, for the Bill.com button.
  onExport?: (source?: string) => void;
  // Which export is running, so the spinner lands on the button that was
  // pressed rather than on both.
  exporting?: "main" | "bill" | null;
};

const InvoicesTableControls = ({ onExport, exporting }: Props) => {
  const dispatch = useAppDispatch();
  const filters = useAppSelector((state) => state?.invoices?.filters);

  const handleStatusFilter = (newStatus: string[]) => {
    dispatch(
      changeInvoicesFilter({ name: "paymentStatus", value: newStatus }),
    );
  };

  const handleClearFilters = () => {
    dispatch(clearFilters());
  };

  return (
    <>
      <PageHeader
        eyebrow="Customers & Billing"
        title="Invoices"
        summary="Every invoice in the active book, its balance, and the link that pays it."
        actions={
          onExport ? (
            <>
              <Button
                variant="secondary"
                size="sm"
                disabled={exporting != null}
                onClick={() => onExport()}
              >
                {exporting === "main" ? (
                  <span
                    className="ui-loading__spinner"
                    style={{ width: 12, height: 12, borderWidth: 2 }}
                  />
                ) : null}
                Export links
              </Button>
              {/* The same rows as the first button, with the Bill.com link for
                  each — the one a client with a legacy balance pays through. */}
              <Button
                variant="secondary"
                size="sm"
                disabled={exporting != null}
                onClick={() => onExport("bill")}
              >
                {exporting === "bill" ? (
                  <span
                    className="ui-loading__spinner"
                    style={{ width: 12, height: 12, borderWidth: 2 }}
                  />
                ) : null}
                Export Bill.com links
              </Button>
            </>
          ) : undefined
        }
      />
      <Toolbar>
        <ChipMultiGroup
          values={filters?.invoices?.paymentStatus || []}
          onChange={handleStatusFilter}
          size="sm"
          options={[
            ["0", "Paid in full"],
            ["1", "Open"],
            ["2", "Partial payment"],
            ["4", "Scheduled"],
          ]}
        />
        <Button variant="ghost" size="sm" onClick={handleClearFilters}>
          Clear
        </Button>
      </Toolbar>
    </>
  );
};

export default InvoicesTableControls;
